export const en = {
  'app.title': 'Chaos Lane',
  'app.round': 'Round {id}',
  'mode.LIVE': 'LIVE',
  'mode.DELAYED_LIVE': 'DELAYED LIVE',
  'mode.RECORDED_DEMO': 'RECORDED DEMO',
  'mode.SIMULATION': 'SIMULATION',
  'mode.SIMULATION.hint': 'Counts come from a scripted fixture, not from camera inference.',
  'conn.connected': 'Connected',
  'conn.reconnecting': 'Reconnecting…',
  'conn.offline': 'Offline',
  'conn.banner': 'Connection lost. Betting is paused until the game reconnects; accepted bets are safe on the server.',
  'balance.demo': 'Demo balance',
  'balance.demoTag': 'DEMO',
  'balance.real': 'Balance',
  'nav.history': 'History',
  'nav.rules': 'Rules',
  'nav.settings': 'Settings',
  'nav.close': 'Close',
  'state.SCHEDULED': 'Scheduled',
  'state.BETTING_OPEN': 'Betting open',
  'state.BETTING_CLOSED': 'Betting closed',
  'state.CAPTURING': 'Counting',
  'state.VERIFYING': 'Verifying',
  'state.REVIEW_REQUIRED': 'Review required',
  'state.RESULT_FINAL': 'Result final',
  'state.SETTLING': 'Settling',
  'state.SETTLED': 'Settled',
  'state.VOIDING': 'Voiding',
  'state.VOIDED': 'Voided',
  'phase.closesIn': 'Betting closes in',
  'phase.countStartsIn': 'Counting starts in',
  'phase.countEndsIn': 'Counting ends in',
  'phase.reviewDeadline': 'Review deadline in',
  'phase.nextRound': 'Next round soon',
  'phase.seconds': '{n} s',
  'count.label': 'Count',
  'count.bands': 'L = {low} · H = {high}',
  'relay.nextCamera': 'Next live camera',
  'relay.starting': 'Bets closed · round starting',
  'outro.count': 'Final count',
  'outro.winning': 'Winning: {sel}',
  'outro.players': '{winners} of {players} players won',
  'outro.noPlayers': 'No bets on this round',
  'outro.paid': '{amount} paid in total',
  'outro.voided': 'Round cancelled: the camera feed was interrupted. Stakes are refunded.',
  'relay.badge': 'LIVE via our relay',
  'relay.connecting': 'Connecting to the live camera…',
  'live.count': 'Count',
  'live.stage': 'Live camera round',
  'live.video': 'Round footage',
  'live.badge': 'DELAYED LIVE · public traffic camera',
  'live.provisional': 'Counting line not yet validated',
  'live.status.betting': 'Betting is open. The next 60 seconds of this camera decide the round.',
  'live.status.capturing': 'Betting closed. Recording the next 60 seconds from this camera…',
  'live.status.preparing': 'Locking and counting the footage. Playback starts shortly.',
  'live.status.retrying': 'Video connection interrupted, reconnecting… The result does not depend on your connection.',
  'live.status.videoUnavailable': 'The footage cannot be played on this device right now. The result is decided on the server and will appear when the round ends.',
  'live.status.voided': 'This round was voided (footage unusable). Stakes are refunded.',
  'video.server.title': 'Counted on the server',
  'video.server.body': 'Crossings are counted by the server from its private camera ingest; this screen does not show the live picture. After the round, Evidence replays the privacy-reduced footage with each crossing.',
  'evidence.lightningCommitOk': 'Revealed seed matches the commitment ✓ (boost draw not re-checked here: the policy is not published to this client)',
  'video.none.title': 'No video in this mode',
  'video.none.body': 'SIMULATION: crossings come from a scripted fixture. Real video counting is not connected yet.',
  'video.testPattern': 'TEST PATTERN · synthetic {ratio} frame for overlay alignment',
  'video.clockUnknown': 'Capture clock unknown',
  'video.lineLocked': 'Counting line locked for this round',
  'sel.UNDER': 'Under',
  'sel.RANGE': 'Range',
  'sel.OVER': 'Over',
  'sel.EXACT': 'Exact',
  'sel.EXACT_LOW': 'Exact Low',
  'sel.EXACT_HIGH': 'Exact High',
  'sel.LANE_A': 'Direction A',
  'sel.LANE_B': 'Direction B',
  'sel.TIE': 'Tie',
  'sel.CAR': 'Car',
  'sel.HEAVY': 'Heavy',
  'sel.MOTORCYCLE': 'Motorcycle',
  'sel.NO_EVENT': 'No event',
  'sel.ZERO': 'Zero',
  'sel.ONE': 'One',
  'sel.TWO_PLUS': 'Two or more',
  'cond.LANE_A': 'More crossings in direction A (arrow side)',
  'cond.LANE_B': 'More crossings in direction B (against the arrow)',
  'cond.TIE': 'Equal counts, including 0–0',
  'cond.CAR': 'First vehicle across the line is a car',
  'cond.HEAVY': 'First vehicle is a bus or truck',
  'cond.MOTORCYCLE': 'First vehicle is a motorcycle',
  'cond.NO_EVENT': 'No vehicle crosses during counting',
  'cond.bucket.exactly': 'Exactly {n}',
  'cond.bucket.atLeast': '{n} or more',
  'cond.bucket.between': '{a} to {b}',
  'duel.a': 'A (arrow side)',
  'duel.b': 'B (against arrow)',
  'first.waiting': 'Waiting for the first vehicle',
  'first.none': 'No vehicle crossed',
  'first.is': 'First: {cls}',
  'count.boats': 'Boats',
  'count.bicycles': 'Bicycles',
  'home.live': 'Live cameras',
  'home.tagline': 'Real traffic cameras from around the world. 60 seconds, one line, one question: how many vehicles will cross?',
  'home.play': 'Play',
  'home.chip.round': '60 s rounds',
  'home.chip.cameras': 'Live roads worldwide',
  'home.chip.demo': 'Demo money',
  'home.chip.real': 'Real money',
  'home.how': 'How to play',
  'home.s1.title': 'Pick your range',
  'home.s1.text': 'Each round offers ranges from that camera’s recent traffic: Few, Exactly, Middle, Exactly, Many. Drop a chip, add as many as you like.',
  'home.s2.title': 'Watch it live',
  'home.s2.text': 'Betting closes, a 10-second countdown runs and the feed starts. Every vehicle crossing the line in the arrow’s direction shows as +1.',
  'home.s3.title': 'The count decides',
  'home.s3.text': 'When the 60 seconds end the count is final. The winning range pays at once; if the feed drops, bets are refunded.',
  'home.s3.badge': 'final count',
  'home.t1.title': 'Real roads',
  'home.t1.text': 'No random number generator: real vehicles on a live camera decide the result.',
  'home.t2.title': 'Rules locked in advance',
  'home.t2.text': 'Camera, line and ranges are fixed before betting opens; counting starts after betting closes.',
  'home.t3.title': 'Everyone sees the same count',
  'home.t3.text': 'Boxes, line and +1s come from the counter itself: what you see is what is counted.',
  'home.foot': 'Demo version · real money off',
  'home.foot.real': 'Real money · 18+ · play responsibly',
  'lobby.title': 'Games',
  'lobby.subtitle': 'Five CCTV games on one demo wallet. Each has its own rules, evaluator and tests.',
  'lobby.play': 'Play',
  'lobby.simulation': 'Simulation rounds',
  'lobby.videoDemo': 'Recorded-video demo: {n} source(s)',
  'lobby.noVideo': 'No licensed video yet',
  'lobby.realMoneyOff': 'Real money: off',
  'lobby.back': 'Home',
  'game.traffic-pulse.title': 'Chaos Lane',
  'game.traffic-pulse.blurb': 'How many vehicles cross the line? Bet on bands around L and H.',
  'game.lane-duel.title': 'Lane Duel',
  'game.lane-duel.blurb': 'Which direction wins: more crossings one way, the other, or a tie?',
  'game.next-class.title': 'Next Class',
  'game.next-class.blurb': 'What is the first vehicle to cross: car, heavy, motorcycle — or nothing?',
  'game.cycle-count.title': 'Cycle Count',
  'game.cycle-count.blurb': 'How many ridden bicycles cross? Pushed bicycles do not count.',
  'game.harbor-count.title': 'Harbor Count',
  'game.harbor-count.blurb': 'How many boats cross the channel line: none, one, or more?',
  'game.limit.cycle-count': 'Pushed-bicycle rule is a v1 heuristic (rider over bicycle), not benchmarked.',
  'game.limit.harbor-count': 'Reflection filter is a v1 heuristic; traffic on the only licensed clip is sparse.',
  'game.limit.next-class': 'Auto-rickshaws have no class of their own in the detector (seen as car/motorcycle/truck).',
  'rules.game': 'Rules ({version})',
  'source.suitable': 'Suits this game',
  'source.otherGames': 'Other licensed sources (not matched to this game)',
  'cond.UNDER': 'Count below {low}',
  'cond.RANGE': 'Count between {low} and {high}, exclusive',
  'cond.OVER': 'Count above {high}',
  'cond.EXACT': 'Count exactly {low} or {high}',
  'cond.EXACT_LOW': 'Count exactly {low}',
  'cond.EXACT_HIGH': 'Count exactly {high}',
  'bet.title': 'Your picks',
  'bet.exampleOdds': 'Example odds — not calibrated. Demo money only.',
  'bet.chip': 'Chip',
  'bet.chipLabel': 'Chip value {amount}',
  'bet.main': 'Main market',
  'bet.side': 'Exact side market',
  'bet.sideNote': 'Separate market: can win together with Exact.',
  'bet.draftOn': 'Draft {amount}',
  'bet.acceptedOn': 'Accepted {amount}',
  'bet.addChip': 'Add {amount} to {selection}',
  'bet.doubleHint': 'Doubles your picks (you still confirm)',
  'board.question': "How many vehicles cross the line in the arrow's direction in {sec} seconds?",
  'board.UNDER': 'Few',
  'board.EXACT_LOW': 'Exactly',
  'board.RANGE': 'Middle',
  'board.EXACT_HIGH': 'Exactly',
  'board.OVER': 'Many',
  'board.EXACT': 'Either one',
  'board.either': '{low} / {high}',
  'sound.turnOn': 'Turn sound on',
  'sound.turnOff': 'Turn sound off',
  'bet.undo': 'Undo',
  'bet.clear': 'Clear',
  'bet.repeat': 'Repeat last',
  'bet.repeatHint': 'Fills the draft only; you still confirm.',
  'bet.total': 'Total stake',
  'bet.potential': 'If {selection} wins: return {gross} (net {net})',
  'bet.confirm': 'Confirm {amount}',
  'bet.confirmEmpty': 'Add chips to bet',
  'bet.submitting': 'Submitting…',
  'bet.closed': 'Betting closed',
  'bet.closedHint': 'Bets reopen with the next round.',
  'bet.offline': 'Reconnecting — betting paused',
  'bet.insufficient': 'Total exceeds your balance',
  'bet.noDebitYet': 'Your balance changes only after the server accepts a bet.',
  'bet.accepted': 'Accepted this round',
  'bet.pending': 'Waiting for server…',
  'bet.result.accepted': '{selection} {amount}: accepted',
  'bet.result.pending': '{selection} {amount}: waiting for your casino wallet to confirm the stake — not accepted yet',
  'bet.result.notConfirmed': '{selection} {amount}: not accepted — your casino wallet did not confirm the stake (nothing was charged by us)',
  'bet.result.rejected': '{selection} {amount}: rejected — {reason}',
  'reason.WALLET_UNAVAILABLE': 'your casino wallet is not answering right now — nothing was charged; try again later',
  'reason.BETTING_CLOSED': 'betting had closed',
  'reason.INSUFFICIENT_FUNDS': 'insufficient balance',
  'reason.SESSION_EXPIRED': 'your site session has ended — return to the site and open the game again',
  'reason.INVALID_STAKE': 'invalid stake',
  'reason.CURRENCY_MISMATCH': 'currency mismatch',
  'reason.QUOTE_CHANGED': 'odds changed',
  'reason.LIABILITY_LIMIT': 'limit reached',
  'reason.SOURCE_UNAVAILABLE': 'source unavailable',
  'reason.IDEMPOTENCY_CONFLICT': 'duplicate request conflict',
  'reason.DEBIT_UNRESOLVED_AT_CLOSE': 'payment not confirmed before close',
  'reason.ROUND_NOT_FOUND': 'round not found',
  'reason.NETWORK': 'connection problem, not sent',
  'result.final': 'Final count {count}',
  'result.winners': 'Winning: {list}',
  'result.youWon': 'Returned {amount}',
  'result.youReturnedLess': 'Returned {amount} (less than your stake)',
  'result.creditPending': 'Return {amount} — credit pending',
  'result.noWin': 'No win this round',
  'result.review': 'An uncertain crossing affects the result. Nothing is published; if review does not finish in time the round is voided and stakes are refunded.',
  'result.voided': 'Round voided. Accepted stakes are refunded.',
  'recent.title': 'Recent results',
  'recent.empty': 'Results appear here as rounds finish.',
  'history.title': 'Bet history',
  'funPlay.tag': 'FUN PLAY',
  'funPlay.hint': 'Play money only: no real stakes, no statistics or prizes.',
  'stats.title': 'My statistics',
  'stats.rounds': 'rounds',
  'stats.bets': 'bets',
  'stats.winRate': 'won',
  'stats.exact': 'exact hits',
  'stats.best': 'best win',
  'stats.minutes': 'minutes played',
  'stats.money': 'Staked {stake} · returned {payout} · net {net}',
  'stats.last30': 'Last 30 days: {rounds} rounds, {wins} wins',
  'stats.favourite': 'favourite: {sel}',
  'ri.title': 'How counting works',
  'ri.lead': 'Before you play: the camera counts vehicles crossing the yellow line in the arrows’ direction. Here is exactly what counts.',
  'ri.direction.title': 'Only in the arrows’ direction',
  'ri.direction.text': 'Vehicles crossing the line the way the yellow arrows point count. The other direction never counts.',
  'ri.middle.title': 'Counted when its middle crosses',
  'ri.middle.text': 'A vehicle counts at the moment the middle of the vehicle passes the line — not before.',
  'ri.big.title': 'Every vehicle counts 1',
  'ri.big.text': 'Car, bus, truck or motorcycle: each one is 1, whatever its size.',
  'ri.hidden.title': 'Only what the camera sees',
  'ri.hidden.text': 'A vehicle hidden behind a bigger one, or outside the picture, cannot be counted.',
  'ri.others.title': 'People and bicycles don’t count',
  'ri.others.text': 'Pedestrians and bicycles are never counted.',
  'ri.time.title': 'Inside the counted minute',
  'ri.time.text': 'Bets close before the counted 60 seconds start. If the picture fails, the round is cancelled and every stake is refunded.',
  'ri.dontShow': 'Don’t show this again',
  'ri.accept': 'I understand — play',
  'ri.leave': 'Back to the home page',
  'ri.error': 'Could not save your confirmation. Please try again.',
  'wallet.down': 'Your casino wallet is not answering, so betting is paused for you. Nothing was charged. We retry automatically — or return to the site and open the game again.',
  'history.empty': 'No bets yet.',
  'history.col.round': 'Round',
  'history.col.pick': 'Pick',
  'history.col.stake': 'Stake',
  'history.col.odds': 'Odds',
  'history.col.count': 'Count',
  'history.col.return': 'Return',
  'history.col.status': 'Status',
  'history.evidence': 'Evidence',
  'history.col.net': 'Net',
  'history.refunded': 'refunded',
  'history.persisted': 'Demo state is kept in this browser so a reload neither loses nor re-pays bets. Demo convenience only — not production storage.',
  'evidence.countedN': 'Counted ({n})',
  'evidence.excludedN': 'Not counted ({n}) — outside the window, wrong direction, excluded class or duplicate',
  'evidence.proof': 'Signatures and witness',
  'evidence.manifestWitness': 'Manifest recorded by witness',
  'evidence.resultWitness': 'Result recorded by witness',
  'evidence.witnessNotIndependent': 'The witness is run by UrbanRats (development); it is not independent.',
  'evidence.segments': 'Media segments (hash chain)',
  'evidence.problems': 'Evidence problems',
  'evidence.redactedNote': 'Replay shows the privacy-reduced rendition; its hash is recorded next to the original.',
  'evidence.replayExpired': 'Replay link expired or unavailable.',
  'evidence.hashNote': 'Hashes and signatures show these records are consistent and existed at the witnessed time. They do not prove the footage is real or the AI count correct.',
  'evidence.replay': 'Replay',
  'evidence.jump': 'Play from {t} s',
  'evidence.window': 'Counting window (media time): {a}–{b} s of {epoch}',
  'evidence.bettingClosed': 'Betting closed (server time): {t}',
  'evidence.recordedNote': 'Recorded footage: the result was knowable in advance. Function demo only.',
  'evidence.voided': 'Round voided — no result was published and accepted stakes were refunded.',
  'evidence.reason': 'Reason: {r}',
  'settings.clearDemo': 'Clear demo data and start over',
  'settings.clearDemoHint': 'Deletes this browser’s demo rounds, bets and balance.',
  'settings.savedAt': 'Demo state saved in this browser at {t}.',
  'history.sessionOnly': 'Demo history is stored in this browser only (demo convenience).',
  'bstate.SUBMITTED': 'Submitted',
  'bstate.DEBIT_PENDING': 'Payment pending',
  'bstate.ACCEPTED': 'Accepted',
  'bstate.REJECTED': 'Rejected',
  'bstate.COMPENSATION_PENDING': 'Refund pending',
  'bstate.COMPENSATED': 'Refunded',
  'bstate.RESULT_WON': 'Won · crediting',
  'bstate.RESULT_LOST': 'Lost · closing',
  'bstate.CREDIT_PENDING': 'Credit pending',
  'bstate.SETTLED': 'Settled',
  'bstate.REFUND_PENDING': 'Refund pending',
  'bstate.VOIDED': 'Voided · refunded',
  'rules.title': 'Rules',
  'rules.what': 'Chaos Lane counts vehicles whose tracked bottom-centre point crosses the counting line segment in the arrow direction during the counting window.',
  'rules.classes': 'Counted: cars, buses, trucks, motorcycles. Not counted: bicycles, wrong direction, vehicles outside the window, the same vehicle twice.',
  'rules.window': 'Betting closes before counting starts. The window is [start, end): a crossing exactly at the end does not count.',
  'rules.bands': 'This round: L = {low}, H = {high}.',
  'rules.bandsCamera': 'L and H are set for each round from this camera\'s own traffic: its last {n} counted minutes (median {median}). They are locked before betting opens.',
  'rules.payout': 'Payout is total return (stake × odds). Net = return − stake. Odds are fixed when your bet is accepted.',
  'rules.review': 'If an uncertain crossing could change the result, the round goes to review. Unresolved review voids the round and refunds stakes.',
  'rules.mode': 'Current mode: {mode}. {hint}',
  'rules.demo': 'This is a demo: demo money, example odds, in-memory state.',
  'evidence.title': 'Round evidence',
  'evidence.status': 'Status',
  'evidence.verified': 'Evidence verified',
  'evidence.confirmed': 'AI count independently confirmed',
  'evidence.no': 'No',
  'evidence.yes': 'Yes',
  'evidence.manifest': 'Manifest hash',
  'evidence.config': 'Config hash',
  'evidence.events': 'Crossing events',
  'evidence.counted': 'counted',
  'evidence.notCounted': 'not counted',
  'evidence.unavailable': 'Evidence is available after the round result.',
  'evidence.simNote': 'SIMULATION_ONLY: events come from a fixture script. This proves nothing about real traffic.',
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.sound': 'Sound',
  'settings.soundOn': 'On',
  'settings.soundOff': 'Muted',
  'settings.motion': 'Reduced motion follows your system setting ({state}).',
  'settings.motionOn': 'on',
  'settings.motionOff': 'off',
  'settings.resetDemo': 'Reset demo balance',
  'settings.resetDemoHint': 'Demo only. Not available while bets are pending.',
  'settings.resetDone': 'Demo balance reset.',
  'settings.resetBlocked': 'Cannot reset while bets are pending.',
  'session.title': 'Session expired',
  'session.body': 'For your security this game session has ended. Reopen the game to continue. Accepted bets are settled on the server.',
  'session.reload': 'Reopen game',
  'session.lobby': 'Back to the site',
  'error.fatal': 'The game cannot start',
  'nav.source': 'Source',
  'source.title': 'Video source',
  'source.simulation': 'Simulation (no video)',
  'source.simulationHint': 'Rounds run with scripted counts. Betting works with demo money.',
  'source.use': 'Use',
  'source.inUse': 'In use',
  'source.available': 'Usable in this demo',
  'source.unavailable': 'Not usable',
  'source.licence': 'Licence: {licence}',
  'source.owner': 'Owner: {owner}',
  'source.loadError': 'Source list could not be loaded.',
  'source.addTitle': 'Add a video you are allowed to use',
  'source.addFile': 'Video file',
  'source.addRights': 'I have the right to use this video in this local demo.',
  'source.addRightsNote': 'This declaration does not prove commercial or broadcast rights. The file stays in this browser; nothing is uploaded. It plays as RECORDED DEMO.',
  'source.addAttribution': 'Source / attribution (optional)',
  'source.addButton': 'Play this file',
  'source.webcamNote': 'Local test only; nothing leaves this device.',
  'srcreason.SNAPSHOT_NOT_SUPPORTED': 'still images only — cannot show crossings',
  'srcreason.REJECTED': 'rejected on terms/rights grounds',
  'srcreason.RIGHTS_PENDING': 'usage rights not granted yet',
  'srcreason.QUARANTINED': 'quarantined',
  'srcreason.RIGHTS_EXPIRED': 'rights expired',
  'srcreason.DISPLAY_NOT_PERMITTED': 'display not permitted',
  'srcreason.CV_NOT_PERMITTED': 'video analysis not permitted',
  'srcreason.NO_ORIGIN': 'no stream address on record',
  'srcreason.MEDIA_FILE_MISSING': 'media file not prepared (npm run media:prepare)',
  'video.counterMissing': 'Counting engine not connected yet (P04): no rounds and no betting on this source.',
  'video.uncalibrated': 'Uncalibrated preview line',
  'video.phase.idle': 'Idle',
  'video.phase.loading': 'Loading',
  'video.phase.playing': 'Playing',
  'video.phase.buffering': 'Buffering',
  'video.phase.paused': 'Paused',
  'video.phase.ended': 'Ended',
  'video.phase.error': 'Error',
  'video.status.ONLINE': 'Picture OK',
  'video.status.DEGRADED': 'Picture degraded',
  'video.status.OFFLINE': 'No live picture',
  'video.error.NETWORK': 'Network error while loading the video.',
  'video.error.DECODE': 'The video could not be decoded (corrupt or unsupported file).',
  'video.error.UNSUPPORTED_OR_BLOCKED': 'The source could not be loaded (unsupported format or blocked by cross-origin policy).',
  'video.error.ABORTED': 'Loading was aborted.',
  'video.error.PERMISSION_DENIED': 'Camera permission was denied.',
  'video.error.NO_DEVICE': 'No camera was found.',
  'video.error.DEVICE_ERROR': 'The camera could not be started.',
  'video.error.STREAM_LOST': 'The camera stream ended.',
  'video.health.FROZEN': 'picture frozen',
  'video.health.STALLED': 'stream stalled',
  'video.health.BUFFERING': 'buffering',
  'video.health.SOURCE_TOO_OLD': 'picture too old',
  'video.health.NOT_PLAYING': 'not playing',
  'video.health.ERROR': 'error',
  'video.health.AGE_UNKNOWN': 'age unknown',
  'video.reconnecting': 'Reconnecting…',
  'video.fps': '{n} fps',
  'video.epoch': 'Epoch {n}',
  'video.age': 'Publish age {s} s (not capture time)',
  'video.retry': 'Retry',
  'video.backToSim': 'Back to simulation',
  'bet.mediaBlocked': 'Video source problem — betting disabled ({reason}).',
  'vision.connecting': 'Connecting to the counting engine…',
  'vision.waiting-frame': 'Counting engine connected — waiting for the first frame',
  'vision.ready': 'Counting from video (inference)',
  'vision.unavailable': 'Counting engine not reachable — start it with: npm run vision:serve',
  'vision.error': 'Counting engine reported an error for this source',
  'vision.waitingRound': 'Next video round opens shortly.',
  'vision.lag': 'worker behind the picture by {s} s',
  'vision.ahead': 'worker {s} s ahead — results are released only when their frame is shown',
  'cal.title': 'Calibration',
  'cal.note': 'Demo operator tool. Saved settings lock into the next round (hash in the manifest); a running round keeps its own.',
  'cal.open': 'Calibrate',
  'cal.setLine': 'Set line (2 clicks)',
  'cal.setRoi': 'Set area (clicks)',
  'cal.finishRoi': 'Finish area',
  'cal.flip': 'Flip direction',
  'cal.pickLine': 'Click the two ends of the counting line on the video.',
  'cal.pickRoi': 'Click the corners of the counting area ({n} so far), then Finish.',
  'cal.classes': 'Counted classes',
  'cal.minConf': 'Minimum confidence {v}',
  'cal.hash': 'Config hash',
  'cal.saved': 'saved',
  'cal.invalid': 'Needs a line and an area with at least 3 corners.',
  'cal.save': 'Save calibration',
  'cal.cancel': 'Cancel',
  'cal.editing': 'Editing calibration',
  'cal.notLocked': 'Line not locked yet — the next round locks it',
  'cal.pending': 'new calibration applies after the current round',
  'bet.noCounter': 'No counting engine for this source yet — betting disabled.',
  'nav.wallet': 'Wallet',
  'nav.rewards': 'Rewards',
  'nav.ranks': 'Leaderboard',
  'ranks.title': 'Leaderboards',
  'ranks.loading': 'Loading…',
  'ranks.empty': 'No leaderboard is running right now.',
  'ranks.ends': 'ends {time}',
  'ranks.you': 'you',
  'ranks.yourRank': 'Your rank',
  'ranks.notRanked': 'Play at least {n} round(s) to enter.',
  'ranks.prizes': 'Prizes',
  'ranks.alias': 'You appear as {alias} — no personal data is shown.',
  'ranks.hm': '{h} h {m} min',
  'ranks.m': '{m} min',
  'metric.ROUNDS': 'Rounds played',
  'metric.PLAY_TIME': 'Time played',
  'metric.BEST_MULTIPLIER': 'Best multiplier',
  'metric.EXACT_HITS': 'Exact hits',
  'metric.WINS': 'Winning bets',
  'metric.ACTIVE_DAYS': 'Active days',
  'metric.STAKE': 'Total stake',
  'metric.NET_WIN': 'Net win',
  'metric.BIGGEST_WIN': 'Biggest win',
  'dropMetric.ROUNDS': 'Play {target} rounds',
  'dropMetric.WINS': 'Win {target} bets',
  'dropMetric.EXACT_HITS': 'Hit {target} exact counts',
  'dropMetric.BEST_MULTIPLIER': 'Win at {target} or more',
  'drop.title': 'Drop chest',
  'drop.goal': 'Goal: {metric}',
  'drop.progress': 'progress {progress} of {target}',
  'drop.open': 'Open the chest',
  'drop.ends': '{left} left',
  'drop.left': '{n} chests left',
  'drop.empty': 'All chests have been opened',
  'drop.won': 'You won {prize}!',
  'drop.fairTitle': 'Provably fair',
  'drop.fair': 'The goal and the prizes were fixed when the drop started. This is the hash of its secret seed; the seed is shown when the drop ends, so anyone can check the draw.',
  'prize.freebet': '{count} × {amount} freebet',
  'prize.boost': '+{pct}% win boost',
  'approx.value': '~{amount}',
  'approx.title': 'Approximate value at an example rate ({provider}, {rateId}, as of {asOf}). Bets and payouts stay in {wallet}.',
  'approx.stale': 'rate expired',
  'wallet.title': 'Wallet and display',
  'wallet.currency': 'Wallet currency',
  'wallet.fromOperator': 'Set by the operator launch for this session. Bets and payouts are always in this currency.',
  'wallet.asset': 'Asset {asset} · network {network} · {scale} decimal places · catalogue {version}',
  'wallet.demoCatalogue': 'Demo catalogue entry: it does not describe any partner contract.',
  'wallet.balance': 'Balance (exact)',
  'wallet.limits': 'Stake per selection: {min} to {max}',
  'wallet.display': 'Show approximate value in',
  'wallet.displayOff': 'Off',
  'wallet.displayNote': 'Approximate only (~), at an example rate that is not market data. Settlement never changes currency.',
  'wallet.quote': 'Rate {rateId} from {provider}, as of {asOf}, valid for {ttl} s. Example rate.',
  'wallet.quoteStale': 'The rate has expired, so no approximate value is shown.',
  'wallet.quoteNone': 'No rate for this pair, so no approximate value is shown.',
  'wallet.region': 'Region (suggestion only)',
  'wallet.regionNone': 'Not set',
  'wallet.regionNote': 'A region only suggests a language and display currency. It does not change your wallet, balance or eligibility.',
  'wallet.regionApply': 'Apply suggestion: {locale}, display {display}',
  'wallet.cashier': 'Deposits, withdrawals and networks are handled by your operator, not inside the game.',
  'wallet.newSession': 'Demo: new session with another wallet currency',
  'wallet.newSessionHint': 'Another wallet currency means a new session. Each demo currency keeps its own demo wallet and history.',
  'wallet.newSessionBlocked': 'Not possible while bets are open. Wait until they settle.',
  'wallet.start': 'Start a {currency} session',
  'rewards.title': 'Rewards',
  'rewards.demo': 'Demo rewards. Real-money promotions are off.',
  'rewards.real': 'Prizes are not offered with real money on this site.',
  'rewards.checkin': 'Daily check-in',
  'rewards.checkinClaim': 'Check in',
  'rewards.checkinDone': 'Checked in today. Next check-in from {t}.',
  'rewards.checkinGranted': 'Added to your inventory: {item}',
  'rewards.checkinStreak': 'Check-in days in a row: {n}',
  'rewards.checkinNote': 'One check-in per UTC day. The reward does not depend on wins or losses.',
  'rewards.level': 'Level {n}',
  'rewards.levelXp': '{xp} / {next} XP',
  'rewards.levelNote': 'Every settled bet gives the same XP, win or lose, whatever the stake. A new level adds a boost to your inventory.',
  'rewards.inventory': 'Inventory',
  'rewards.empty': 'No rewards yet.',
  'rewards.freebet': 'Freebet {amount}',
  'rewards.boost': 'Payout boost +{pct}%',
  'rewards.policy.PROFIT_ONLY': 'profit only: a win pays the return minus the freebet value',
  'rewards.policy.STAKE_INCLUDED': 'stake included: a win pays the full return',
  'rewards.expires': 'Expires {t}',
  'rewards.noExpiry': 'No expiry',
  'rewards.state.GRANTED': 'Available',
  'rewards.state.RESERVED': 'In use',
  'rewards.state.CONSUMED': 'Used',
  'rewards.state.CANCELLED': 'Cancelled',
  'rewards.state.EXPIRED': 'Expired',
  'rewards.origin.OPERATOR_GRANT': 'From the operator',
  'rewards.origin.DAILY_CHECKIN': 'Daily check-in',
  'rewards.origin.LEVEL_UP': 'Level reward',
  'rewards.allGames': 'all games',
  'rewards.games': 'Valid for: {games}',
  'rewards.notMoney': 'Rewards are not part of your balance.',
  'rewards.lightning': 'Lightning',
  'rewards.lightningBody': 'When betting opens, Lightning may boost the odds of one main-market selection. The boost only changes the payout if that selection wins; it never affects the count or the result. The draw is committed (hash) before betting and its seed is published in the round evidence, so anyone can check it.',
  'rewards.lightningCols': 'Tier · chance · multiplier',
  'rewards.lightningExact': 'Exact side market: not in the Lightning pool ({version}).',
  'rewards.terms': 'Terms',
  'rewards.cap': 'Maximum total return per bet: {cap}',
  'rewards.formula': 'Payout formula ({version}): {formula}',
  'rewards.stackFreebetLightning': 'Freebets cannot be used on a Lightning selection.',
  'rewards.stackBoostLightning': 'Boosts combine with Lightning in the same formula.',
  'rewards.onePerBet': 'One reward per bet; boosts up to +{pct}%.',
  'rewards.voidPolicy': 'If a round is voided, a used reward returns to your inventory unless it has expired.',
  'tier.COMMON': 'Common',
  'tier.RARE': 'Rare',
  'tier.EPIC': 'Epic',
  'tier.LEGENDARY': 'Legendary',
  'bet.lightning': '⚡ {tier} ×{factor}',
  'bet.lightningAria': 'Lightning {tier}: payout ×{factor} if this selection wins',
  'bet.lightningNote': 'Lightning is fixed for this round and only raises the payout. Your picks are not changed.',
  'bet.cap': 'Max return per bet: {cap}',
  'bet.reward': 'Use a reward',
  'bet.rewardNone': 'No reward',
  'bet.rewardFreebet': 'Freebet {amount} ({policy})',
  'bet.rewardBoost': 'Boost +{pct}%',
  'bet.rewardOneLine': 'A reward applies to one selection. Keep one selection in the draft.',
  'bet.rewardFreebetHint': 'Tap a selection to place the freebet ({amount}). No cash is debited.',
  'bet.rewardFreebetFace': 'The freebet stake is fixed at {amount}.',
  'bet.amount': 'Custom amount',
  'bet.amountSet': 'Use',
  'bet.amountHint': 'Type or paste in your format, e.g. {example}',
  'bet.approxTotal': 'Approx. {amount}',
  'amount.INVALID_DECIMAL': 'Not a valid amount.',
  'amount.INVALID_ATOMIC': 'Not a valid amount.',
  'amount.AMBIGUOUS_SEPARATORS': 'The separators don’t match your number format (e.g. {example}).',
  'amount.PRECISION_OVERFLOW': 'Too many decimal places for {currency} (at most {scale}).',
  'amount.NEGATIVE': 'Amounts cannot be negative.',
  'amount.TOO_LARGE': 'Amount too large.',
  'amount.ZERO': 'The amount must be greater than zero.',
  'amount.CURRENCY_MISMATCH': 'Wrong currency.',
  'amount.LIMIT': 'Outside the stake limits ({min} to {max}).',
  'reason.STAKE_LIMIT': 'outside the stake limits',
  'reason.REWARD_UNAVAILABLE': 'reward not available',
  'reason.PROMO_NOT_STACKABLE': 'rewards cannot be combined this way',
  'history.freebet': 'Freebet',
  'history.lightning': 'Lightning ×{f}',
  'history.boost': 'Boost +{pct}%',
  'history.cashDebit': 'Cash debited',
  'evidence.lightning': 'Lightning',
  'evidence.lightningOk': 'The seed matches the commitment and reproduces the published boosts ✓',
  'evidence.lightningBad': 'Seed check failed ✕',
  'evidence.lightningSeed': 'Seed',
  'evidence.lightningCommit': 'Commitment',
  'evidence.lightningNone': 'No Lightning in this round.',
  'settings.moreLocales': '{n} more languages are prepared and will be listed once fully translated.',
} as const;

export type MessageKey = keyof typeof en;
